import script from "./FourInARowPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FourInARowPage.vue?vue&type=script&setup=true&lang=js"

import "./FourInARowPage.vue?vue&type=style&index=0&id=b6c9a736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6c9a736"]])

export default __exports__